import React from "react";
import { Stack } from "@mui/material";

/**
 * Contenedor de los campos de un selector de reporte, dentro del modal.
 * En escritorio mide 480 px; en el teléfono ocupa el ancho del modal (el margen
 * negativo recupera parte del relleno del diálogo para que Desde y Hasta quepan en una fila).
 * 82 px = margen del diálogo (64) + su borde (2) + relleno (48) − margen negativo (32).
 */
export const FormularioSelector = ({ children }) => (
  <Stack
    spacing={2.5}
    sx={{
      pt: 1,
      mx: { xs: -2, sm: 0 },
      width: { xs: "calc(100vw - 82px)", sm: 480 },
    }}
  >
    {children}
  </Stack>
);
